module.exports = __webpack_public_path__ + "static/media/scale_icon.d1114e20.svg";